module.exports = __webpack_public_path__ + "img/icon-layers.fc32f268.svg";